import MuiTextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import colors from '$variables/colors';

// eslint-disable-next-line import/prefer-default-export
export const TextField = withStyles({
  root: {
    height: '36px',
    '& label.Mui-disabled': {
      color: colors.grey1,
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: colors.olive,
      },
      '&.Mui-disabled fieldset': {
        borderColor: colors.grey1,
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: colors.olive,
      },
      '&.Mui-disabled MuiOutlinedInput-notchedOutline': {
        borderColor: colors.grey1,
      },
      '& input': {
        fontSize: '14px',
        lineHeight: '24px',
      },
      '&.Mui-disabled input': {
        color: colors.black,
      },
    },
    '& .MuiInputLabel-outlined': {
      fontSize: '14px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontSize: '16px',
      color: colors.olive,
    },
    '& .Mui-disabled.MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: colors.grey1,
    },
  },
})(MuiTextField);
